/** @jsxImportSource @emotion/react */
"use client";

import { useTranslations } from "@i18n/react";
import { HallowAnalyticsEvent, useAnalytics } from "@packages/analytics";
import { useCurrentQueueItem } from "@packages/media";
import { MediaOptionsIcon, ModalTab } from "@packages/ui";
import { HallowDataTestId } from "@tools/playwright/global";

import { useMediaAnalyticsProps } from "../../../../hooks/useMediaAnalyticsProps";
import type { MediaMenuTabProps } from "../MediaMenu.emotion";

export const SelectLengthTab = ({ disabled }: MediaMenuTabProps) => {
  const t = useTranslations();
  const { currentItem } = useCurrentQueueItem();
  const { track } = useAnalytics();
  const analyticsProps = useMediaAnalyticsProps();

  return (
    <ModalTab
      key={"lengthSelectMenuTab"}
      value={"lengthSelectMenu"}
      data-testid={HallowDataTestId.MediaSettingsTab}
      startIcon={<MediaOptionsIcon />}
      label={t("track_settings_length")}
      disabled={disabled}
      onClick={() =>
        track({
          event: HallowAnalyticsEvent.TappedLength,
          properties: analyticsProps,
        })
      }
    >
      {currentItem.selected_audio.length}
    </ModalTab>
  );
};
